import { ElementType, memo } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import { IMenuItem } from '@types'
import s from './MenuItem.module.scss'

const aboutUsPaths = [
  '/puppy-travel',
  '/mission',
  '/reviews',
  '/faq/customer',
  '/referral',
  '/contact',
  '/about-mawoo-pets',
  '/why-mawoo-pets',
  '/insurance',
]

const MenuItem = memo(({ title, href = '', path, className }: IMenuItem) => {
  const isActive = () => {
    if (path === href) return true
    if (href === 'about-us') return aboutUsPaths.includes(path)
    if (href === 'puppies')
      return path.startsWith('/puppies-for-sale/') || path === '/search'
    return false
  }

  const isInteractive = href === 'about-us' || href === 'puppies'
  const Wrapper: ElementType = isInteractive ? 'div' : Link
  const wrapperProps = isInteractive ? {} : { href }

  return (
    <Wrapper className={cn(s.menuItemLink, className)} {...wrapperProps}>
      <div className={s.menuItem}>
        <div className={s.title}>{title}</div>
        <div
          className={cn(s.bar, {
            [s.activeBar]: isActive(),
          })}
        />
      </div>
    </Wrapper>
  )
})

export default MenuItem
